// src/components/ui/Button.tsx
import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'white' | 'black' | 'outline'; // Define the button style variants
  width?: string; // Allow customizable width
}

const Button: React.FC<ButtonProps> = ({ children, variant = 'white', width, ...props }) => {
  return (
    <button
      {...props}
      style={{
        ...styles.button,
        ...styles[variant],
        width: width || 'auto', // Apply custom width if provided
      }}
    >
      {children}
    </button>
  );
};

const styles = {
  button: {
    height: '52px',
    padding: '10px 20px',
    border: 'none',
    borderRadius: '12px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: '600',
    fontFamily: 'Montserrat',
  } as React.CSSProperties,
  white: {
    backgroundColor: '#fff',
    color: '#000',
  } as React.CSSProperties,
  black: {
    backgroundColor: '#000',
    color: '#fff',
  } as React.CSSProperties,
  outline: {
    backgroundColor: 'transparent',
    color: '#fff',
    border: '1px solid #474747',
  } as React.CSSProperties,
};

export default Button;
